<template>
  <div>
    <div class="parent">
      <div class="tooltip z-20" :class="bg">{{ value }}</div>
      <slot>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "tooltip",
  props: {
    value: {
      type: String,
      default: 'Message tooltip'
    },
    bg:{
      type:String,
      Default:'bg-blue-700'
    }
  }
}
</script>

<style scoped>
.tooltip {
  /*background: black;*/
  color: white;
  cursor: pointer;
  padding: .5rem .75rem;
  border-radius: .25rem;
  position: absolute;
  top: -2rem;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: visibility 0s, opacity .4s, top .4s;
}

.tooltip::before {
  content: '';
  display: block;
  width: 15px;
  height: 15px;
  background: inherit;
  position: absolute;
  bottom: -7.5px;
  left: 50%;
  transform: translate(-50%) rotate(45deg);
}

.parent {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.parent:hover .tooltip {
  visibility: visible;
  opacity: 1;
  top: -3rem;
}
</style>
